<template>
  <div style="padding:15px;">
    <modal
      v-if="mapper"
      ref="modal"
      id="agMapperModal"
      classes="modal-container"
      styles="display:flex; flex-direction:column; padding:15px;"
      v-model="showMapperModal"
      :draggable="true"
      :resizable="true"
      name="mapperModal"
      width="1114px"
      height="85%"
      :shiftX=.5
      :shiftY=0
      drag="drag"
      content-class="modal-content"
      resize="resize"
      :fit-parent="true"
      :resize-directions="['br']"
      :clickToClose="false"
      :key="reload"
      @keyup.enter.native="saveButton_click"
    >
      <div>
        <h4 v-if="disableUI" class="agModal-title">View Mapper</h4>
        <h4 v-else class="agModal-title">Edit Mapper</h4>
        <hr />
      </div>
      <div class="inner" style="height: 100%; overflow-y: auto; overflow-x:hidden; position:relative;">
        <div class="agInputGroup agInputGroupCentered">
          <label>Source:</label>
          <b-input
            type="text"
            :value="srcStr"
            autocomplete="false"
            disabled
          ></b-input>
        </div>
        <b-input-group style="padding:14px;" size="md" prepend="Name">
          <b-input
            type="text"
            v-model="mapper.name"
            autocomplete="false"
            :disabled="disableUI"
          ></b-input>
        </b-input-group>
        <b-input-group style="padding:14px;" size="md" prepend="Description">
          <b-input
            type="text"
            v-model="mapper.description"
            autocomplete="false"
            :disabled="disableUI"
          ></b-input>
        </b-input-group>
        <hr />
        <div class="agInputGroup agInputGroupCentered">
          <label>Map To:</label>
          <b-form-select
            id="agMapperModal-mapObject"
            class="agLargeInput"
            v-model="mapper.mapObject"
            :options="mapObjects"
            :disabled="disableUI"
            @change="mapObjectSelect_change"
          ></b-form-select>
        </div>
        <hr />
        <div class="agInputGroup">
          <b-table
            :key="'mods-' + reloadMods"
            id="agMapperModal-modTable"
            :fields="modHeaders"
            :items="mods"
            :thead-class="{ theadHidden: isLoadingMods }"
            borderless
            outlined
            small
          >
            <template #cell(field)="data">
              <b-form-select
                v-model="data.item.field"
                class="agMapperModal-field"
                disabled
              >
                <option :value="data.value">{{
                  getFieldText(data.value)
                }}</option>
              </b-form-select>
            </template>
            <template slot="=">
              <div class="agMapperModal-modEquals">=</div>
            </template>
            <template #cell(value)="data">
              <ag-input-select
                :useSubInput="true"
                :inputModel="data.item.value.value"
                :selectModel="data.item.value.field"
                :workflow="workflow"
                :groups="values"
                :width="400"
                :disabled="disableUI"
                @input_keyup="modValueInput_keyup($event, data.index)"
                @select_change="modValueSelect_change($event, data.index)"
              ></ag-input-select>
            </template>
          </b-table>
          <b-spinner
            v-if="isLoadingMods"
            id="agMapperModal-loadingModsSpinner"
          ></b-spinner>
        </div>
        <hr />
        <div class="agInputGroup agInputGroupCentered">
          <label>Destination:</label>
          <b-input
            type="text"
            :value="destName"
            autocomplete="false"
            disabled
          ></b-input>
        </div>
        <div v-if="modalMessage">
          <hr />
          <label class="agModal-message" :class="modalMessageClass">{{
            modalMessage
          }}</label>
        </div>
      </div>
      <div>
        <hr />
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          :disabled="disableUI || isLoading"
          @click="deleteButton_click"
          style="margin-left:82%;"
          >Delete</b-button
        >
        <b-button class="agModal-buttonLeft" @click="cancelButton_click"
          >Cancel</b-button
        >
        <b-button
          class="agModal-buttonRight"
          style="float:right;"
          variant="primary"
          :disabled="disableUI || isLoading"
          @click="saveButton_click"
          >Save</b-button
        >
      </div>

      <!-- delete modal -->
      <b-modal
        class="agModal"
        ref="deleteModal"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @keyup.enter.native="deleteButton_click"
      >
        <template slot="modal-header">
          <h4 class="agModal-title danger">Delete Mapper</h4>
        </template>
        Are you sure you want to delete mapper
        <i>{{ name }}</i
        >?
        <template slot="modal-footer" slot-scope="{ cancel }">
          <b-button class="agModal-buttonLeft" @click="cancel"
            >Cancel</b-button
          >
          <b-button
            class="agModal-buttonRight"
            variant="danger"
            @click="confirmDeleteButton_click"
            >Delete</b-button
          >
        </template>
      </b-modal>
    </modal>
  </div>
</template>

<script>
// components
import InputSelect from "comp/ui/InputSelect";

// modules
import Util from "src/util/util";
import _ from "lodash";

export default {
  name: "ag-mapper-modal",
  components: {
    "ag-input-select": InputSelect
  },
  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean
  },
  data() {
    return {
      showMapperModal: false,
      reload: 0,
      mapper: null,
      reloadMods: 0,
      isLoading: false,
      isLoadingMods: false,
      modalMessage: "",
      modalMessageClass: "",
      mapObjects: [],
      mods: [],
      modHeaders: ["field", "=", "value"],
      values: {}
    };
  },
  computed: {
    name() {
      if (this.mapper.name) {
        return this.mapper.name;
      }
      return this.mapper.shortname;
    },

    srcStr() {
      if (!this.mapper.src || this.mapper.src.length == 0) return "";

      var srcStr = "";
      for (var i = 0; i < this.mapper.src.length; i++) {
        var src = this.mapper.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    },

    destName() {
      if (this.mapper.dest) return this.mapper.dest.shortname;
      return "";
    }
  },

  watch: {},

  methods: {
    // UI Events
    cancelButton_click() {
      this.$modal.hide("mapperModal");
      this.mapper = false;
    },
    async saveButton_click() {
      this.modalMessage = "";

      // build mapper.mods w/ mods that actually have values
      var validMods = [];
      for (var i = 0; i < this.mods.length; i++) {
        var mod = this.mods[i];
        if (mod.value.value || mod.value.field) {
          validMods.push(mod);
        }
      }
      this.mapper.mods = validMods;

      var node = {
        object: this.mapper,
        type: "mapper"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "mapper",
          object: result.data.node
        };
        this.hide();
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.mapper,
        type: "mapper"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();
    },

    mapObjectSelect_change() {
      setTimeout(() => {
        this.setValues();
        this.setMods();
      }, 250);
    },

    modValueInput_keyup(value, index) {
      var mod = this.mods[index];
      mod.value.value = value;
      mod.value.field = null;
    },

    modValueSelect_change(value, index) {
      var mod = this.mods[index];
      if (value.field == "-- None --") {
        mod.value.field = null;
        this.reloadMods++;
      } else {
        mod.value.field = value;
      }
      mod.value.value = null;
    },

    // other
    show() {
      this.setMapper();
      setTimeout(() => {
        this.reset();
        this.$modal.show("mapperModal", { draggable: true });
        this.showMapperModal = true;
      }, 250);
    },

    hide() {
      this.$modal.hide('mapperModal');
    },

    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";

      setTimeout(() => {
        this.setMapObjects();
        this.setValues();
        this.setMods();
      }, 250);
    },

    setMapper() {
      if (this.node && this.node.type == "mapper")
        this.mapper = this.workflow.mappers.find(
          object => object._id == this.node.object._id
        );
      else this.mapper = null;
    },

    async setMapObjects() {
      this.mapObjects = [];

      var types = this.$store.getters["nodeStore/getOutputTypes"];
      for (var i = 0; i < types.length; i++) {
        var type = types[i];
        if (!type.plural) continue;

        for (var j = 0; j < this.workflow[type.plural].length; j++) {
          var output = this.workflow[type.plural][j];
          var name = output.shortname;
          if (output.name) {
            name += ": " + output.name;
          }
          var value = {
            type: type.type,
            shortname: output.shortname
          };

          var option = { value: value, text: name };
          this.mapObjects.push(option);
        }
      }
    },

    async setMods() {
      this.isLoadingMods = true;
      this.mods = [];

      if (!this.mapper.mapObject) {
        this.isLoadingMods = false;
        this.reloadMods++;
        return;
      }
      var fields;
      var outputFields = Util.getOutputFields(this.$store, this.workflow);
      for(let i =0;i<Object.keys(outputFields).length;i++){
        if(outputFields[Object.keys(outputFields)[i]][0].object.includes(this.mapper.mapObject.shortname)){
          fields = outputFields[Object.keys(outputFields)[i]];
        }
      }
      if (!fields) {
        this.isLoadingMods = false;
        this.reloadMods++;
        return;
      }
      
      for (var i = 0; i < fields.length; i++) {
        var field = fields[i];
        var mod = {
          field: field
        };
        var existing = null;
        for (let m = 0; m < this.mapper.mods.length; m++) {
          let mm = this.mapper.mods[m];
          if (mm.field.field == field.field) {
            if (mm.field.child && field.child) {
              if (mm.field.child.shortname == field.child.shortname) {
                existing = mm;
              }
            } else {
              existing = mm;
            }
          }
        }
        if (existing) {
          mod.value = {
            field: existing.value.field,
            value: existing.value.value
          };
        } else {
          mod.value = {
            field: null,
            value: null
          };
        }
        this.mods.push(mod);

      this.isLoadingMods = false;
      this.reloadMods++;
      }
    },

    async setValues() {
      // add -- None -- to be able to blank out fields
      this.values = {
        " ": [
          {
            value: { object: "", field: "-- None --" },
            text: "-- None --"
          }
        ]
      };
      var inputFields = Util.getInputFields(this.$store, this.workflow);
      var optionGroups = Util.fieldsToOptionGroups(inputFields);
      Object.assign(this.values, optionGroups);
    },

    getFieldText(field) {
      if (field.child) {
        var output = this.workflow.outputs.find(
          a => a.shortname == this.mapper.mapObject.shortname
        );
        var child = output.childObjects.find(
          a => a.shortname == field.child.shortname
        );
        if (child) {
          if((child.value) !==undefined){
            var text = child.shortname + ": " + child.name+"." + field.field+" "+ child.value;
            return text;
          }else{
            var text = child.shortname + ": " + child.name+"." + field.field;
            return text;
          }
        }
      }
      return field.field;
    }
  }
};
</script>

<style scoped lang="css">
#agMapperModal-modTable {
  text-align: center;
  width: 1000px;
  margin: auto;
}

#agMapperModal-loadingModsSpinner {
  position: relative;
  left: 50%;
  margin-left: -20px;
}

.agMapperModal-field {
  width: 400px;
  display: inline-block;

  -webkit-appearance: none;
  -moz-appearance: none;
}

.agMapperModal-field::-ms-expand {
  display: none;
}

.agMapperModal-modEquals {
  width: 200px;
  margin-top: 7.5px;
}

</style>



// WEBPACK FOOTER //
// src/components/nodes/MapperModal.vue